/**
 * 1.6.61: 密码强度校验工具
 * 规则: 至少 8 位，必须包含字母 + 数字 + 特殊符号
 */

export const PASSWORD_MIN_LENGTH = 8;

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
  checks: {
    length: boolean;
    letter: boolean;
    digit: boolean;
    special: boolean;
  };
}

/**
 * 校验密码强度
 * - 至少 8 位
 * - 必须包含至少 1 个字母（大写或小写）
 * - 必须包含至少 1 个数字
 * - 必须包含至少 1 个特殊符号
 */
export function validatePasswordStrength(password: string): PasswordValidationResult {
  const checks = {
    length: password.length >= PASSWORD_MIN_LENGTH,
    letter: /[a-zA-Z]/.test(password),
    digit: /\d/.test(password),
    special: /[^a-zA-Z0-9]/.test(password),
  };

  const errors: string[] = [];
  if (!checks.length) errors.push('length');
  if (!checks.letter) errors.push('letter');
  if (!checks.digit) errors.push('digit');
  if (!checks.special) errors.push('special');

  return {
    isValid: errors.length === 0,
    errors,
    checks,
  };
}
